import React from 'react';
import { get } from 'lodash/fp';
import { Table, Icon, IconButton } from 'rsuite';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { modifyAccess, fullAccess } from '../../../../helpers/permission';
import * as PERMISSIONS from '../../../../constants/permissions/storage';
import AccessControl from '../../../AccessControl';
import createItemPathFor from '../../../../helpers/createItemPathFor';
import StorageImage from '../../Image';
import Link from '../../../Link';

const { Cell } = Table;

const ImageWrapper = styled.div`
  width: 40px;
  height: 40px;
  background: #f5f5f5;
  border-radius: 20px;
  margin-top: 2px;
  overflow: hidden;
  display: inline-block;
`;

export const ActionCell = ({
  rowData,
  dataKey,
  handleDelete,
  handleEdit,
  ...props
}) => (
  <Cell {...props} className="link-group">
    <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.DEVICE)}>
      <IconButton
        appearance="link"
        style={{ top: '-8px' }}
        color="blue"
        icon={<Icon icon="edit2" />}
        onClick={() => handleEdit(rowData)}
      />
    </AccessControl>
    <AccessControl allowOnlyFor={fullAccess(PERMISSIONS.DEVICE)}>
      <IconButton
        style={{ top: '-8px' }}
        appearance="link"
        color="red"
        onClick={() => handleDelete(rowData)}
        icon={<Icon icon="trash" />}
      />
    </AccessControl>
  </Cell>
);
ActionCell.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    photo: PropTypes.string
  }),
  dataKey: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired
};
ActionCell.defaultProps = {
  rowData: null
};

export const LinkCell = ({ rowData, dataKey, ...props }) => (
  <Cell {...props} className="link-group">
    <Link to={createItemPathFor('view', rowData)}>{get(dataKey, rowData)}</Link>
  </Cell>
);

LinkCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })
};

LinkCell.defaultProps = {
  rowData: null
};

export const ImageLinkCell = ({ rowData, dataKey, ...props }) => (
  <Cell {...props} style={{ padding: 0 }}>
    <Link to={createItemPathFor('view', rowData)}>
      <ImageWrapper>
        <StorageImage image={get(dataKey, rowData)} style={{ width: 40 }} />
      </ImageWrapper>
    </Link>
  </Cell>
);

ImageLinkCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    photo: PropTypes.string
  })
};

ImageLinkCell.defaultProps = {
  rowData: null
};
